import { getEnvVars } from "@/lib/common/get-env-vars";
import { registerInstrumentations } from "@opentelemetry/instrumentation";
import { XMLHttpRequestInstrumentation } from "@opentelemetry/instrumentation-xml-http-request";
import { WebTracerProvider } from "@opentelemetry/sdk-trace-web";

const { env } = getEnvVars();

const createApiUrlRegex = (apiUrl: string) => {
  try {
    const url = new URL(apiUrl);
    return new RegExp(String.raw`^https?:\/\/${url.hostname}(:\d+)?\/`);
  } catch {
    return /$^/;
  }
};

export const initializeOpenTelemetry = () => {
  const provider = new WebTracerProvider();

  provider.register();

  const apiUrl = env.APP_API_URL;
  const apiRegex = createApiUrlRegex(apiUrl);

  registerInstrumentations({
    instrumentations: [
      new XMLHttpRequestInstrumentation({
        propagateTraceHeaderCorsUrls: [apiRegex]
      })
    ]
  });
};
